import React, { useEffect, useState } from "react";

import "./UserCompaniesItemDetails.scss";
import { useTranslation } from "react-i18next";
import { Checkbox, Divider, Grid } from "@material-ui/core";
import { Mode } from "../../../../../../shared/constants";
import DetailComponent from "../../../../common-components/details-component";
import UserCompaniesFormItem from "../../../../common-components/forms/user-companies-form";
import { getCompanyNameView } from "../../../../common-components/utils";

const defaultUserCompanyFormData = {
  daily_rate: { value: null, error: false },
  hourly_rate: { value: null, error: false },
  company_role: { value: null, error: false },
  is_daily_rate: { value: true, error: false },
}

const UserCompanyItemDetails = (props) => {
  const { company, onChange, userCompany, mode } = props;
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(!!userCompany)
  const [companyUserFormData, setCompanyUserFormData] = useState(
    !userCompany ?
      defaultUserCompanyFormData :
      {
        daily_rate: { value: userCompany.daily_rate, error: false },
        hourly_rate: { value: userCompany.hourly_rate, error: false },
        company_role: { value: userCompany.company_role, error: false },
        is_daily_rate: { value: userCompany.is_daily_rate, error: false },
      });

  useEffect(() => {
    onChange(!expanded ? null : {
      ...(userCompany || {}),
      daily_rate: companyUserFormData.daily_rate.value,
      hourly_rate: companyUserFormData.hourly_rate.value,
      company_role: companyUserFormData.company_role.value,
      is_daily_rate: companyUserFormData.is_daily_rate.value,
      company_id: company.id
    });
    // eslint-disable-next-line
  }, [companyUserFormData, expanded]);

  if (mode === Mode.view && !userCompany)
    return null;

  return <div className="user-companies-details-item">
    <div className="user-companies-details-item-header">
      <Grid container>
        {mode === Mode.edit &&
        <Grid xs={1} item className="vertically-center">
          <Checkbox checked={expanded} onChange={(e) => setExpanded(e.target.checked)}/>
        </Grid>}
        <Grid xs={11} item className="vertically-center user-companies-details-item-title">
          {getCompanyNameView(company, t)}
        </Grid>
      </Grid>
    </div>
    {expanded && <Divider className="user-companies-details-divider"/>}
    {expanded && <div className="user-companies-details-item-content">
      {mode === Mode.view && <Grid container spacing={3}>
        <Grid item xs={6}><DetailComponent label={t("daily-rate")} value={userCompany.daily_rate}/></Grid>
        <Grid item xs={6}><DetailComponent label={t("hourly-rate")} value={userCompany.hourly_rate}/></Grid>
        <Grid item xs={6}><DetailComponent label={t("role")} value={t(userCompany.company_role)}/></Grid>
        <Grid item xs={6}><DetailComponent label={t("is-use-daily-rate")}
                                           value={userCompany.is_daily_rate ? t("yes") : t("no")}/></Grid>
      </Grid>}
      {mode === Mode.edit && <UserCompaniesFormItem
        companyUserFormData={companyUserFormData}
        setCompanyUserFormData={setCompanyUserFormData}/>}
    </div>}
  </div>

}

export default UserCompanyItemDetails;